import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import HeroSlider from "@/pages/home/components/HeroSlider";
import IntroSection from "@/pages/home/components/IntroSection";
import ServiceCards from "@/components/feature/ServiceCards";
import AboutSection from "@/pages/home/components/AboutSection";
import ContactCTA from "@/pages/home/components/ContactCTA";

export default function HomeEnPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="NetBasis International - linking people & business"
        description="Your local DACH presence for foreign ICT firms. Seamless market entry through our full-service representation or tailored modular growth solutions."
        ogUrl="https://net-basis.net/en"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <HeroSlider
          texts={{
            slide1_title: "New markets, new business ... no risk!",
            slide2_title: "With us straight into the heart of Europe!",
            slide3_title: "Germany (DACH) – Your success with a local partner!",
            slide4_title: "Stronger together!",
            slide4_subtitle: "Business Development\nConsulting Services\nInterim Management\nTraining & Coaching",
            slide5_title: "Start now!",
            prev_slide: "Previous slide",
            next_slide: "Next slide",
            slide_label: "Slide {{number}}",
            alts: [
              "Finger touches a networked digital globe for low-risk ICT market entry.",
              "Finger marks Europe on a networked world map for ICT market entry.",
              "Blue map of Germany with federal states symbolizes local ICT partnership in the DACH market.",
              "Businessman uses a digital interface for ICT services for DACH market entry.",
              "Finger activates a digital start icon for successful ICT market entry in Europe.",
            ],
          }}
        />

        <IntroSection
          texts={{
            title: "NetBasis International - linking people & business",
            heading:
              "Your operational partner for a successful market entry into the DACH region. We support and drive your local market activities – tailored to your needs, whether by managing your entire local operations or providing flexible support for specific areas.",
            paragraph1:
              "Building, scaling, and expanding business in new markets must be one thing above all for foreign companies: promising, fast, efficient, cost-effective, and secure. Lengthy market studies, complex strategy development with unclear decision-making processes, or a lack of direct market access are invariably the wrong approach. Furthermore, manufacturers often seek to enter a new market without major upfront investments.",
            paragraph2:
              "This is precisely where NetBasis International comes in as your trusted partner. For nearly 20 years, we have been successfully guiding and supporting foreign companies from the ICT industry in attractive yet demanding markets – with a clear focus on the German-speaking economic area (the DACH region).",
            strong_name: "NetBasis International",
          }}
        />

        <ServiceCards
          namespace="home"
          titleKeys={[
            "services.service1_title",
            "services.service2_title",
            "services.service3_title",
            "services.service4_title",
          ]}
          descriptionKeys={[
            "services.service1_description",
            "services.service2_description",
            "services.service3_description",
            "services.service4_description",
          ]}
          readMoreKey="services.read_more"
          texts={{
            titles: [
              "Business Development",
              "Consulting Services",
              "Interim Management",
              "Training & Coaching",
            ],
            descriptions: [
              "DACH market success? We pave the way! With us, doors will open. We roll up our sleeves and make it happen!",
              "Know how it's done? We provide clear insight! We advise with foresight. We protect your project!",
              "Temporary need? We cover it competently! We close the gap. We provide you with peace of mind!",
              "New markets in sight? We get you ready! We train for real practice. We secure your venture!",
            ],
            readMore: "Learn more",
          }}
        />

        <AboutSection
          texts={{
            title: "NetBasis International - drive to excellence with excellent drivers!",
            paragraph1:
              "As recognized experts based in Germany – Europe’s most important market – we at NetBasis International help you identify entry barriers, evaluate strategic options, develop realistic marketing concepts, find suitable partners, and approach potential customers directly. Reliable and results-oriented, we offer a comprehensive range of services, including market entry and development planning, sales, marketing, public relations, technical support, and, if required, talent acquisition.",
            paragraph2:
              "By partnering with us, you benefit from a single point of contact for your entire project. You gain immediate access to the essential know-how and operational expertise indispensable for your market success. With our pragmatic and results-driven approach, we work alongside you to navigate the specific conditions and requirements of your target countries.",
            paragraph3:
              "The choice of how to utilize our expertise is entirely yours: We can manage the entire project and act as your local boots on the ground for a fixed or indefinite period. Alternatively, we can support you selectively with individual tasks, act purely as consultants on your journey, or cooperate with you in training and coaching.",
            paragraph4:
              "Whichever services you select: NetBasis International aligns all relevant resources and measures perfectly to drive your business forward efficiently.",
            strong_name: "NetBasis International",
          }}
        />

        <ContactCTA
          texts={{
            title: "Get in touch with us directly now.",
            cta_button: "Contact Form",
            link_url: "/en/contact",
          }}
        />
      </main>

      <Footer />
    </div>
  );
}